import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';

import { FooterComponent } from '@/layout/components/footer/footer.component';
import { AuthService } from '@/features/auth/auth.service';
import { IdleTimerService } from '@/features/auth/service/idle-timer.service';
import { TranslateModule } from '@ngx-translate/core';

import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PrimeNG } from 'primeng/config';

import { MobileFloatMenuComponent } from '@/features/pagina-comprador/components/mobile-float-menu/mobile-float-menu.component';
import { CarrinhoService } from '@/features/pagina-comprador/services/carrinho.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FooterComponent,
    ToastModule,
    ConfirmDialogModule,
    TranslateModule,
    MobileFloatMenuComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit, OnDestroy {
  showChrome = true;
  isMobile = false;
  cartCount = 0;

  nomeComprador = '';
  numeroCarteiraSelecionada = 'Sem Carteira';

  private routerSub?: Subscription;
  private cartSub?: Subscription;

  private compradorDadosHandler = (event: Event): void => {
    const custom = event as CustomEvent;

    this.nomeComprador =
      custom.detail?.nomeComprador ||
      localStorage.getItem('nome_comprador') ||
      localStorage.getItem('nomeUsuario') ||
      '';

    this.numeroCarteiraSelecionada =
      custom.detail?.numeroCarteira ||
      localStorage.getItem('selected_carteira_numero') ||
      'Sem Carteira';
  };

  constructor(
    private config: PrimeNG,
    private router: Router,
    public idle: IdleTimerService,
    private auth: AuthService,
    private cart: CarrinhoService
  ) { }

  ngOnInit(): void {
    this.checkScreen();
    this.configurePrimeNg();
    this.listenRouter();
    this.listenCart();
    this.carregarDadosCompradorMenu();

    window.addEventListener(
      'comprador-dados-updated',
      this.compradorDadosHandler
    );
  }

  format(secs: number): string {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  private configurePrimeNg(): void {
    this.config.setTranslation({
      dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
      monthNames: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoje',
      clear: 'Limpar'
    });
  }

  private carregarDadosCompradorMenu(): void {
    this.nomeComprador =
      localStorage.getItem('nome_comprador') ||
      localStorage.getItem('nomeUsuario') ||
      '';

    this.numeroCarteiraSelecionada =
      localStorage.getItem('selected_carteira_numero') ||
      'Sem Carteira';
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkScreen();
  }

  private checkScreen(): void {
    this.isMobile = window.innerWidth <= 480;
  }

  private listenRouter(): void {
    // mantém igual
  }

  private listenCart(): void {
    this.cartSub = this.cart.items$.subscribe((items: any[]) => {
      this.cartCount = items?.length || 0;
    });
  }

  toggleMenu(): void {
    window.dispatchEvent(new CustomEvent('mobile-menu-toggle'));
  }

  toggleFilters(): void {
    window.dispatchEvent(new CustomEvent('mobile-filters-toggle'));
  }

  toggleCart(): void {
    window.dispatchEvent(new CustomEvent('mobile-cart-toggle'));
  }

  toggleAccount(): void {
    window.dispatchEvent(new CustomEvent('mobile-account-toggle'));
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.cartSub?.unsubscribe();

    window.removeEventListener(
      'comprador-dados-updated',
      this.compradorDadosHandler
    );

    this.idle.stop();
  }
}